import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class PiBlacklistFilter {
    includes = [];
    excludes = [];
    list = [];
    blacklist = [];

    public start(list) {
        this.includes = [];
        this.excludes = [];
        this.list = list;

        return this;
    }

    public input(blacklist: []) {
        this.blacklist = Array.isArray(blacklist) ? blacklist : [];

        return this;
    }

    public filter() {
        this.blacklist.forEach(name => {
            const found = this.list.find(entry => {
                return entry.Name === name;
            });

            if (found) {
                this.excludes.push(found);
            }
        });

        return this;
    }

    public exclude() {
        return Array.from(this.excludes);
    }

    public include() {
        return Array.from(this.includes);
    }
}
